import type { OnboardingRequirementCollectCardData } from '@onefootprint/request-types';
import type { CardFormData } from '../types';

const createPayload = (formData: CardFormData, requirement: OnboardingRequirementCollectCardData) => {
  const cardAlias = requirement.cardAlias;
  const payload = {
    [`card.${cardAlias}.number`]: formData.cardNumber.replace(/\s/g, ''),
    [`card.${cardAlias}.name`]: formData.name,
  };

  if ('cvc' in formData && requirement.collectCvc) {
    payload[`card.${cardAlias}.cvc`] = formData.cvc;
  }
  if ('expiry' in formData && requirement.collectExpiration) {
    payload[`card.${cardAlias}.expiration`] = formData.expiry;
  }
  if ('zip' in formData && requirement.collectBillingZip) {
    payload[`card.${cardAlias}.billing_address.zip`] = formData.zip;
  }
  if ('country' in formData && requirement.collectBillingCountry) {
    payload[`card.${cardAlias}.billing_address.country`] = formData.country;
  }

  return payload;
};

export default createPayload;
